<script>
import { cloneDeep } from 'lodash';
import { isBefore, parseISO, startOfDay } from 'date-fns';
import MessageFormRow from './message-form-row';

import MessagesApi from '@/api/messages';

export default {
  name: 'ParamMessage',
  components: {
    MessageFormRow
  },
  data: () => ({
    messages: [],
    loading: true,
    displayHisto: false
  }),
  computed: {
    messagesEnCours () {
      return this.messages.filter(m =>
        (!m.dateFin || !isBefore(parseISO(m.dateFin), startOfDay(Date.now())))
      );
    },
    historique () {
      return this.messages.filter(m =>
        m.dateFin && isBefore(parseISO(m.dateFin), startOfDay(Date.now()))
      );
    },
    textesList () {
      return this.messages.map(m => m.texte).filter(m => !!m);
    }
  },
  created () {
    MessagesApi.getMessages().then(messages => {
      this.messages = messages.filter(m => m.id !== -1);
    }).finally(() => { this.loading = false; });
  },
  methods: {
    ajouter (texte) {
      const message = {};
      Object.defineProperty(message, '__new', { configurable: true, writable: true, value: true });
      Object.defineProperty(message, '__modification', { configurable: true, writable: true, value: true });
      Object.defineProperty(message, '__originalValue', { configurable: true, value: cloneDeep(message) });
      this.$forceUpdate();
      if (texte) {
        message.texte = texte;
      }
      this.messages.push(message);
    },
    deleteFromLocalList (message) {
      const index = this.messages.indexOf(message);
      if (~index) {
        this.messages.splice(index, 1);
        this.$forceUpdate();
      }
    },
    supprimer (message) {
      if (!message.__new) {
        this.loading = true;
        MessagesApi.deleteMessage(message).then(() => {
          this.deleteFromLocalList(message);
          this.$forceUpdate();
        }).finally(() => { this.loading = false; });
      } else {
        this.deleteFromLocalList(message);
      }
    }
  }
};
</script>

<template>
  <div>
    <Loader v-if="loading" />
    <h2>Paramètres - Bannière de messages</h2>
    <table>
      <MessageFormRow
        v-for="message in messagesEnCours"
        :key="message.id"
        :message="message"
        :textes-list="textesList"
        @delete="deleteFromLocalList(message)"
      />
      <tr>
        <v-btn @click="ajouter()">
          Ajouter <v-icon>mdi-plus</v-icon>
        </v-btn>
      </tr>
    </table>
    <h3 class="mt-16 mb-6">
      Historique des messages <v-btn
        v-if="!displayHisto"
        outlined
        @click="displayHisto = true"
      >
        Afficher
      </v-btn>
    </h3>
    <table v-if="displayHisto">
      <tr
        v-for="(message) in historique"
        :key="message.id"
      >
        <td>
          <div class="inputs">
            <div>
              <v-text-field
                :value="message.texte"
                disabled
                label="Message"
              />
            </div>
            <div>
              <v-text-field
                :value="message.dateDebut |date"
                disabled
                label="Date de début"
                class="mx-12"
              />
              <v-text-field
                :value="message.dateFin |date"
                disabled
                label="Date de fin"
                class="mx-12"
              />
            </div>
          </div>
        </td>
        <td>
          <div class="actions">
            <v-btn
              outlined
              @click="ajouter(message.texte)"
            >
              Copier <v-icon>mdi-copy</v-icon>
            </v-btn>
            <v-btn
              color="error"
              outlined
              @click="supprimer(message)"
            >
              Supprimer <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss" scoped>
td{
  border-bottom: 2em solid transparent;
}

.inputs{
  display: flex;
  flex-direction: column;
  width: 800px;

  &>*{
    display: flex;
    flex-direction:row;
    justify-content: space-around;
  }
}

.actions{
  display: flex;
  flex-direction: column;
  margin-left:2em;;

  &>*:not(:last-child){
    margin-bottom: 0.7em;
  }
}
</style>
